export const STR = {
  es: {
    welcome_tag: "demo interactiva · datos de ejemplo",
    welcome_title: (n) => `Mesa ${n}`,
    welcome_sub: "pedí desde acá, sin esperar al mozo",
    table: (n) => `Mesa ${n}`,
    see_menu: "ver menú",
    powered: "conocé la vista de gerencia y dueño arriba",
    categories: { entradas: "entradas", principales: "principales", pastas: "pastas", postres: "postres", bebidas: "bebidas", vinos: "vinos" },
    tag_labels: { "vegano": "vegano", "sin TACC": "sin TACC", "picante": "picante" },
    sold_out: "agotado",
    add: "agregar",
    note: "nota",
    note_placeholder: "ej: sin cebolla",
    your_order: "tu pedido",
    cart_empty: "Tu carrito está vacío",
    subtotal: "subtotal",
    view_order: "ver pedido",
    items: "ítems",
    itemCount: (n) => `${n} ítem${n === 1 ? "" : "s"}`,
    tip_label: "propina",
    your_name: "tu nombre (opcional)",
    name_placeholder: "ej: Caro",
    ordered_by: "pidió",
    share_table: "sumar otro celular a la mesa",
    share_msg: "Escaneá este QR desde otro celular para pedir en la misma mesa. Ven los mismos ítems en vivo, marcados con quién los pidió.",
    ask_waiter: "pedíselo al mozo",
    waiting_approval: "esperando confirmación del mozo",
    tip_to: (dest) => `propina para: ${dest === "mozo" ? "el mozo de la mesa" : dest === "local" ? "el local" : "el pozo común"}`,
    waiter_collects: "El mozo se acerca a cobrarte",
    pay_on_order: "pagás al confirmar el pedido",
    pay_at_end: "pagás al final",
    drink_suggestion: "¿Le sumás una bebida?",
    add_drink: "sumar limonada",
    confirm_order: "confirmar pedido",
    tracking: "seguimiento",
    steps: ["recibido", "en cocina", "listo", "entregado"],
    call_waiter: "llamar al mozo",
    waiter_called: "Listo, ya avisamos al mozo",
    order_more: "pedir algo más",
    ask_bill: "pedir la cuenta",
    bill: "la cuenta",
    tip_q: "¿Dejás propina?",
    no_tip: "sin propina",
    other: "otro monto",
    split: "dividir cuenta",
    split_equal: "en partes iguales",
    split_items: "por ítem",
    people: "personas",
    each_pays: "paga cada uno",
    your_share: "tu parte",
    pick_items: "tildá lo que pagás vos",
    you_pay: "pagás",
    pay_with: "¿cómo pagás?",
    continue: "continuar",
    pay_now: "pagar",
    back: "volver",
    total: "total",
    with_tip: "con propina",
    receipt: "comprobante",
    receipt_msg: "Gracias por venir. Guardá tu comprobante.",
    send_email: "recibirlo por email",
    send_wa: "recibirlo por WhatsApp",
    review_q: "¿cómo estuvo todo?",
    google_cta: "dejanos tu reseña en Google",
    private_cta: "contanos qué pasó",
    private_placeholder: "Escribí acá tu comentario (llega solo a la gerencia)",
    whatsapp_optional: "Tu WhatsApp (opcional, para que te contacte el encargado)",
    send: "enviar",
    thanks_review: "Gracias por tu reseña",
    cash_msg: "Ya le avisamos a la caja, en un momento se acercan a cobrarte",
    cash_waiting: "esperando cobro en efectivo",
    cash_paid: "cobrado, gracias",
    transfer_msg: "Transferí a este alias y avisanos:",
    copied: "copiado",
    already_paid: "ya transferí",
    alias: "alias",
    cbu: "CVU",
    copy: "copiar",
    installments: "cuotas",
    card_number: "número de tarjeta",
    card_name: "nombre y apellido",
    card_expiry: "vencimiento",
    card_cvv: "código",
    card_test_hint: "tarjeta de prueba precargada: podés editarla",
    processing: "procesando…",
    approved: "pago aprobado",
    new_round: "pedido nuevo agregado a tu mesa",
    mp_balance: "dinero en cuenta",
    mp_saved_card: "tarjeta guardada",
    modo_msg: "Se abrió la app de tu banco para confirmar el pago",
    guide_tracking: "mirá cómo le llega a la gerencia",
    guide_bill: "mirá la alerta que le llega a la gerencia",
    guide_cash: "ahora la caja confirma el cobro en gerencia",
    guide_review: "mirá cómo llega tu reseña a gerencia y al dueño",
    guide_btn: "ver en gerencia →",
    guide_btn_owner: "ver en dueño →",
    tagline: "comida de estación, vino de la casa",
    order_label: "Pedido",
    no_orders: "Todavía no hiciste ningún pedido en esta ronda.",
    tip_word: "propina",
    simulation: "simulación",
    mp_charges: "Bodegón Demo te cobra",
    available: "disponible",
    modo_confirm: "confirmar en la app del banco",
    method_labels: { mercadopago: "Mercado Pago", modo: "MODO", tarjeta: "Tarjeta de débito o crédito", transferencia: "Transferencia", efectivo: "Efectivo" },
    card_title: "Tarjeta de débito o crédito",
    installment_one: (v) => `1 cuota de ${v}`,
    installment_n: (n, v) => `${n} cuotas de ${v}`,
    transfer_title: "Transferencia bancaria",
    cash_title: "Efectivo",
    cash_prepare: (v) => `Prepará ${v}. Le avisamos a la caja.`,
    cash_confirm: "confirmar · pago en la mesa",
    receipt_sim: "comprobante simulado",
    payment_method: "medio de pago",
    toast_email: "Comprobante enviado a tu email (simulado)",
    toast_wa: "Comprobante enviado por WhatsApp (simulado)",
    google_redirect: "redirección simulada",
    google_reviews: "google · reseñas",
    google_placeholder: "“Escribí tu reseña acá…”",
    google_publish: "publicar reseña",
    done_title: "gracias por venir",
    done_sub: "Te esperamos la próxima en Bodegón Demo.",
    done_restart: "volver al inicio",
    note_hint: "se aplica al tocar “agregar”",
  },
  en: {
    welcome_tag: "interactive demo · sample data",
    welcome_title: (n) => `Table ${n}`,
    welcome_sub: "order from here, no waiting for the waiter",
    table: (n) => `Table ${n}`,
    see_menu: "see menu",
    powered: "check the manager & owner views above",
    categories: { entradas: "starters", principales: "mains", pastas: "pasta", postres: "desserts", bebidas: "drinks", vinos: "wines" },
    tag_labels: { "vegano": "vegan", "sin TACC": "gluten-free", "picante": "spicy" },
    sold_out: "sold out",
    add: "add",
    note: "note",
    note_placeholder: "e.g. no onion",
    your_order: "your order",
    cart_empty: "Your cart is empty",
    subtotal: "subtotal",
    view_order: "view order",
    items: "items",
    itemCount: (n) => `${n} item${n === 1 ? "" : "s"}`,
    tip_label: "tip",
    your_name: "your name (optional)",
    name_placeholder: "e.g. Caro",
    ordered_by: "ordered by",
    share_table: "add another phone to this table",
    share_msg: "Scan this QR from another phone to order at the same table. You both see the same items live, tagged with who ordered them.",
    ask_waiter: "ask the waiter",
    waiting_approval: "waiting for the waiter's confirmation",
    tip_to: (dest) => `tip goes to: ${dest === "mozo" ? "your waiter" : dest === "local" ? "the house" : "the shared pool"}`,
    waiter_collects: "The waiter comes to charge you",
    pay_on_order: "pay when you order",
    pay_at_end: "pay at the end",
    drink_suggestion: "Add a drink?",
    add_drink: "add lemonade",
    confirm_order: "confirm order",
    tracking: "tracking",
    steps: ["received", "cooking", "ready", "served"],
    call_waiter: "call the waiter",
    waiter_called: "Done, waiter notified",
    order_more: "order more",
    ask_bill: "ask for the bill",
    bill: "the bill",
    tip_q: "Leaving a tip?",
    no_tip: "no tip",
    other: "other amount",
    split: "split the bill",
    split_equal: "split evenly",
    split_items: "by item",
    people: "people",
    each_pays: "each pays",
    your_share: "your share",
    pick_items: "tick the items you pay for",
    you_pay: "you pay",
    pay_with: "how do you pay?",
    continue: "continue",
    pay_now: "pay",
    back: "back",
    total: "total",
    with_tip: "with tip",
    receipt: "receipt",
    receipt_msg: "Thanks for coming. Keep your receipt.",
    send_email: "get it by email",
    send_wa: "get it by WhatsApp",
    review_q: "how was everything?",
    google_cta: "leave us a Google review",
    private_cta: "tell us what happened",
    private_placeholder: "Write your comment here (only management sees it)",
    whatsapp_optional: "Your WhatsApp (optional, so the manager can reach you)",
    send: "send",
    thanks_review: "Thanks for your review",
    cash_msg: "We've told the cashier, they'll come to your table shortly",
    cash_waiting: "waiting for cash payment",
    cash_paid: "paid, thank you",
    transfer_msg: "Transfer to this alias and let us know:",
    copied: "copied",
    already_paid: "I already transferred",
    alias: "alias",
    cbu: "CVU",
    copy: "copy",
    installments: "installments",
    card_number: "card number",
    card_name: "full name",
    card_expiry: "expiry",
    card_cvv: "CVV",
    card_test_hint: "test card preloaded: you can edit it",
    processing: "processing…",
    approved: "payment approved",
    new_round: "new order added to your table",
    mp_balance: "account balance",
    mp_saved_card: "saved card",
    modo_msg: "Your bank app opened to confirm the payment",
    guide_tracking: "watch it arrive at the manager's board",
    guide_bill: "watch the alert reach the manager",
    guide_cash: "now the cashier confirms the payment in the manager view",
    guide_review: "see your review reach the manager and the owner",
    guide_btn: "see in manager view →",
    guide_btn_owner: "see in owner view →",
    tagline: "seasonal food, house wine",
    order_label: "Order",
    no_orders: "You haven't ordered anything this round yet.",
    tip_word: "tip",
    simulation: "simulation",
    mp_charges: "Bodegón Demo is charging you",
    available: "available",
    modo_confirm: "confirm in your bank app",
    method_labels: { mercadopago: "Mercado Pago", modo: "MODO", tarjeta: "Debit or credit card", transferencia: "Bank transfer", efectivo: "Cash" },
    card_title: "Debit or credit card",
    installment_one: (v) => `1 installment of ${v}`,
    installment_n: (n, v) => `${n} installments of ${v}`,
    transfer_title: "Bank transfer",
    cash_title: "Cash",
    cash_prepare: (v) => `Have ${v} ready. We'll let the cashier know.`,
    cash_confirm: "confirm · pay at the table",
    receipt_sim: "simulated receipt",
    payment_method: "payment method",
    toast_email: "Receipt sent to your email (simulated)",
    toast_wa: "Receipt sent via WhatsApp (simulated)",
    google_redirect: "simulated redirect",
    google_reviews: "google · reviews",
    google_placeholder: "“Write your review here…”",
    google_publish: "post review",
    done_title: "thanks for coming",
    done_sub: "Hope to see you again at Bodegón Demo.",
    done_restart: "back to start",
    note_hint: "applies when you tap “add”",
  },
};
